import { createSelector } from 'reselect';
import { utils } from '@saucelabs/sl-module-performance';

const performanceContainer = (store) => store.apps.extendedDebugging;
const job = (store) => store.apps.job;

const containerSelector = createSelector(
  performanceContainer,
  job,
  (store) => store.user,
  (store) => store.apps.performance,
  (performanceState, jobState, user, performance) => ({
    loading: performanceState.container.get('loading'),
    job: jobState.job.get('job'),
    user,
    performanceAccessType: performance.access.get('accessType'),
    regressionURLList: utils.prepareRegressionList(performance.regression.get('performanceRegressions')),
    showAcknowledgeBanner: performance.regression.get('showAcknowledgeBanner'),
  }));

export {
  performanceContainer,
  containerSelector,
  job,
};
